export default {
  API_BASE_URL: process.env.VUE_APP_API_BASE_URL,
  GOOGLE_MAPS_API_KEY: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
  AUTH_DEVICE_NAME: process.env.VUE_APP_AUTH_DEVICE_NAME,
};
